import { Helmet } from 'react-helmet-async'
import { useIntl } from 'react-intl'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useLimitedHeaderFooter } from '../../../containers/app/AppState/useLimitedHeaderFooter'
import { useTrackRegistrationLead } from '../../../services/engagement-tracking/useTrackRegistrationLead'
import { canonicalUrl } from '../../../utils/htmlHead'
import meta from '../../metaDescriptions'
import { SUBSCRIBE_WIZARD_PATH } from '../constants'
import { WizardStateProvider } from '../useWizardState'
import Variant1Step1ChoosePlan from './Step1ChoosePlan/Step1ChoosePlan'
import Variant1Step2RegAndPay from './Step2Subscribe/Step2Subscribe'
import Variant1Step3VerifyEmail from './Step3VerifyEmail/Step3VerifyEmail'

const SubscribeWizard = ({ location: { state = {} } }) => {
  const { limitedHeaderFooter } = state
  useTrackRegistrationLead({ trackOnMount: true })
  useLimitedHeaderFooter(Boolean(limitedHeaderFooter))
  const intl = useIntl()
  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(meta.signUpTitle)}</title>
        <meta property="og:title" content="Sign-up to Flix Premiere" />
        <meta
          name="description"
          property="og:description"
          content={intl.formatMessage(meta.signUp)}
        />
        <meta property="og:url" content={canonicalUrl(SUBSCRIBE_WIZARD_PATH)} />
        <link rel="canonical" href={canonicalUrl(SUBSCRIBE_WIZARD_PATH)} />
      </Helmet>

      <WizardStateProvider {...state}>
        <Switch>
          <Route
            path={`${SUBSCRIBE_WIZARD_PATH}/choose-plan`}
            component={Variant1Step1ChoosePlan}
          />
          <Route path={`${SUBSCRIBE_WIZARD_PATH}/subscribe`} component={Variant1Step2RegAndPay} />
          <Route path={`${SUBSCRIBE_WIZARD_PATH}/verify`} component={Variant1Step3VerifyEmail} />
          <Redirect to={`${SUBSCRIBE_WIZARD_PATH}/choose-plan`} />
        </Switch>
      </WizardStateProvider>
    </>
  )
}

export default SubscribeWizard
